import {Component, ChangeDetectionStrategy, ViewEncapsulation, OnInit, Inject} from '@angular/core';

import { ModelService } from '../shared/model/model.service';

declare let $:any;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'home',
  styles: [ require('./home.component.css') ],
  template: require('./home.component.html')
})
export class HomeComponent implements OnInit {

  isBrowser: boolean;

  ngOnInit(): void {
    if(this.isBrowser){
      $(document).ready(function () {
        $("#home-carousel-mobile").carousel({interval: 5000});
        $("#home-carousel").carousel({interval: 5000});
      });
    }
  }

  constructor(@Inject('isBrowser') isBrowser: boolean) {
    this.isBrowser = isBrowser;
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+home/home.component.ts